import React from 'react'
import Skeleton from 'react-loading-skeleton'

function EditorsPickSkeleton() {
    return (
        <div className="col-lg-6 col-md-6 item mt-4">
            <div className="card">
                <div className="card-header p-0 position-relative">
                    <a href={`/posts/`}>
                        <Skeleton height={`15em`} width={`23em`} />
                    </a>
                </div>
                <div className="card-body blog-details">
                    <span className="label-blue"><a href={`/cateogary/`}><Skeleton width={`4em`} /></a></span>
                    <br />
                    <a href={`/posts/`} className="blog-desc"><Skeleton width={`14.5em`} /></a>
                    <a href={`/posts/`} className="blog-desc" style={{ marginTop: `-2em` }}><Skeleton width={`7em`} /></a>
                    <br />
                    <Skeleton width={`20em`} />
                    <Skeleton width={`20em`} />
                    <Skeleton width={`10em`} />
                    <div className="author align-items-center mt-3 mb-1">
                        <Skeleton className="img-fluid rounded-circle" width={`3em`} height={`3em`} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditorsPickSkeleton
